<template>
  <div class="groupSend">
    <div class="head-title">企业群发</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、当企业需要向众多客户发送节日祝福、促销活动、新产品上市等消息，管理员可在后台剪辑好文案，可包括文章、图片、小程序等内容。
          </p>
          <p>2、创建任务可分不同成员、客户标签、客户群等内容进行分类发布。</p>
          <p>
            3、员工收到群发任务后并确认发布，这样能提升企业的工作效率，利用群发机会，做好客户的营销和服务。
          </p>
          <p>4、每位客户/每个客户群每天可接收1条群发消息。</p>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="mMain">
      <nav class="navbar">
        <div class="narbar-l">
          <span class="shij">
            <el-button @click="addrun()" icon="el-icon-plus" type="primary">新建群发</el-button>
          </span>
          <span class="shij">
            <el-button @click="toggleSelection()" icon="el-icon-delete" >删除</el-button>
          </span>
        </div>
        <div class="narbar-r">
          <el-input clearable placeholder="请输入任务名称搜索" style="width: 35.0rem"
            prefix-icon="el-icon-search" v-model="input2" @change="rune()">
            <el-button slot="append" @click="rune()" type="primary">查询</el-button>
          </el-input>

        </div>
      </nav>
      <el-table :data="tableData.data" border style="width: 100%; margin-top: 2.0rem" v-loading="tableLoading"
        @selection-change="handleSelectionChange" >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column prop="name" label="任务名称" style="width: 14.28%;" show-overflow-tooltip></el-table-column>
        <el-table-column prop="scope" label="发送范围" style="width: 14.28%;"></el-table-column>
        <el-table-column prop="if_send" label="发送类型" style="width: 14.28%;"></el-table-column>
        <el-table-column prop="msgtype_name" label="附件类型" style="width: 14.28%;"></el-table-column>
        <el-table-column prop="username" label="发送人员" style="width: 14.28%;">
          <template slot-scope="scope">
            <el-popover placement="left" trigger="hover">
              <template v-for="item in scope.row.username">
                <div v-html="item"></div>
              </template>
              <div slot="reference">
                <div v-if="scope.row.username == '暂无'">
                  {{ scope.row.username }}
                </div>
                <div v-else class="set-content">
                  <el-tag size="mini" style="margin: .2rem" v-for="(i, index) in scope.row.username" :key="index">{{ i
                  }}</el-tag>
                </div>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="group_label" label="客户标签" style="width: 14.28%;">
          <template slot-scope="scope">
            <el-popover placement="left" trigger="hover">
              <template v-for="item in scope.row.group_label">
                <div v-html="item"></div>
              </template>
              <div slot="reference">
                <div v-if="scope.row.group_label == '暂无'">
                  <el-tag size="mini" style="margin: .2rem" v-for="(i, index) in scope.row.group_label" :key="index">{{ i
                  }}</el-tag>
                </div>
                <div v-else class="set-content">
                  <el-tag size="mini" style="margin: .2rem" v-for="(i, index) in scope.row.group_label" :key="index">{{ i
                  }}</el-tag>

                </div>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="发送内容" style="width: 14.28%;" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="cont">
              {{ scope.row.content }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createtime" label="创建时间" style="width: 14.28%;"></el-table-column>
        <el-table-column label="发送时间" style="width: 14.28%;">
            <template slot-scope="scope">
                {{ scope.row.send_time | timestampToTime }}
            </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <!-- <template v-if="scope.row.status === '成功'">
              <i class="el-icon-success" style="color: #6fc24d; font-size: 2.0rem; vertical-align: middle"></i>
            </template>
            <template v-else>
              <i class="el-icon-error" style="color: #f43939; font-size: 2.0rem; vertical-align: middle"></i>
            </template> -->
            <el-tag v-if="scope.row.status === '成功'"  size="mini" type="success" >{{ scope.row.status }}</el-tag>
            <el-tag v-else  type="danger" size="mini" >{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="170">
          <template slot-scope="scope">
            <el-button  type="text" size="mini" @click="handleStatistics(scope.row)">查看完成情况</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
      :total="tableData.total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      :page-sizes="[10,20,50,100]"
      :auto-scroll="false"
      @pagination="userTable" />
    </div>
    <el-dialog title="完成情况"  center :visible.sync="dialogVisible" >
      <div>
        <el-table  tooltip-effect="dark" style="width: 100%" :data="tableList" border>
          <el-table-column prop="avatar" label="头像">
            <template slot-scope="scope">
              <el-image style="width: 5.0rem; height: 5.0rem" :src="scope.row.avatar"
                :preview-src-list="[scope.row.avatar]"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名"> </el-table-column>
          <el-table-column prop="status_name" label="完成情况">
            <template slot-scope="scope">
              <el-tag  v-if="scope.row.status == 0" size="mini" type="danger">未发送</el-tag>
              <el-tag  v-else-if="scope.row.status == 1" size="mini" type="success">已发送</el-tag>
              <el-tag  v-else size="mini" type="warning">{{ scope.row.status_name }}</el-tag>

            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination :total="totalList"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      :page-sizes="[10,20,50,100]"
      @pagination="getGroupSendResult" />
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Pagination from "@/components/Pagination";
export default {
  name: "monitoring",
  components: {
    Pagination,
  },
  data() {
    return {
      title: {},
      tooken: "",
      tableData: {
        total: 0,
      },
      input2: "",
      onSubmit: false,
      onSubmitn: false,
      tableData_a: [],
      multipleSelection: "",
      value1: true,
      form: {
        name: "",
        none: "",
        customer_deal_days: "",
        customer_follow_days: "",
      },
      ele: "",
      yeshu: 1,
      bianjile: "",
      customer_deal_days: "",
      customer_follow_days: "",
      lock: true,
      code: "",
      listQuery: {
        page: 1,
        limit: 20,
      },
      dialogVisible: false,
      tableList: [],
      totalList: 0,
      tableLoading: true
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.userTable();
  },
  filters: {
    timestampToTime(timestamp) {
      let date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear();
      let M = (date.getMonth() + 1).toString().padStart(2, 0);
      let D = date.getDate().toString().padStart(2, 0);
      let h = date.getHours().toString().padStart(2, 0);
      let m = date.getMinutes().toString().padStart(2, 0);
      return `${Y}-${M}-${D} ${h}:${m}`;
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "success-row";
    },
    toggleSelection() {
      if(this.multipleSelection == ""){
        this.$message.error("请勾选你要删除的选项");
        return
      }

      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/Assistant/delMassNew",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
                ids: this.multipleSelection,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              if (res.data.code == 1) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.userTable();
              } else if (res.data.code == 0) {
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSelectionChange(val) {
      var arr = [];
      val.map((i) => {
        arr.push(i.id);
      });
      this.multipleSelection = arr.toString();
    },
    handleStatistics(row) {
      this.dialogVisible = true;
      this.getGroupSendResult(row.id);
    },
    async getGroupSendResult(id) {
      try {
        const { data: res } = await this.axios({
          url: "/crm/Assistant/getGroupmsgSendResult",
          method: "POST",
          data: this.qs.stringify({
            id: id,
            page: this.listQuery.page,
            number_page: this.listQuery.limit,
          }),
        });
        if (res.code == 1) {
          this.tableList = res.data;
          this.totalList = res.count;
        } else {
          this.tableList = [];
          this.totalList = res.count;
        }
      } catch (error) {
        console.log(error);
      }
    },
    addrun() {
      this.$router.push({
        name: "groupSendAdd",
      });
    },
    /*
    //  页数
    handleCurrentChange(val) {
      this.pageSize = val;
      this.userTable();
    },*/
    userTable() {
      this.axios
        .post(
          "/crm/Assistant/getMassListNew",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.name,
            page: this.listQuery.page,
            number_page:this.listQuery.limit,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableLoading = false
          this.tableData = res.data.data;
        })
        .catch(function (err) { });
    },
    rune() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/Assistant/getMassListNew",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.input2,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) { });
    },
    tianjia() {
      this.yeshu = 1;
      this.axios
        .post(
          "/home/sessionUser/ifRemoveUserTwo",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) { });
    },
    bianji(e, o, l, p) {
      this.yeshu = 1;
      this.ele = e;
      this.bianjile = o;
      this.customer_follow_days = l;
      this.customer_deal_days = p;
    },
    // 修改
    numoon() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/CustomerLevel/editCustomerLevel",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            name: this.bianjile,
            id: this.ele,
            customer_follow_days: this.customer_follow_days,
            customer_deal_days: this.customer_deal_days,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmitn = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmitn = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) { });
    },
    // 添加
    numoo() {
      this.yeshu = 1;
      this.axios
        .post(
          "/crm/CustomerLevel/addCustomerLevel",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,

            phone: this.tooken.phone,
            name: this.form.name,
            customer_follow_days: this.form.customer_follow_days,
            customer_deal_days: this.form.customer_deal_days,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.onSubmit = false;
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.onSubmit = true;
            this.$message.error(res.data.msg);
          }
          this.userTable();
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          this.tableData_a = res.data.data;
        })
        .catch(function (err) { });
    },
    // 移除
    handleClick(e, o) {
      this.yeshu = 1;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/crm/CustomerLevel/delCustomerLevel",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                id: e,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.userTable();
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.tableData_a = res.data.data;
            })
            .catch(function (err) { });
        })
        .catch(() => { });
    },
  },
};
</script>
<style scoped>

.hello {
  width: 100%;
  height: 100%;
  padding: 2.0rem;
  overflow: hidden;
  overflow-y: auto;
}

.navbar {
  display: flex;
  justify-content: space-between;
}

.shij {
  display: inline-block;
  margin-right: 2.4rem;
}

.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  -webkit-box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
}

.cont {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 3.0rem;
  font-size: 1.5rem;
}
.el-dialog .el-table thead th{
background: #F6FFFA !important;
}
.el-table .el-button{
  background: none !important;
    color: #000 !important;
    font-size: 1.6rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #317AF8 !important;
    line-height: 2.2rem;
    padding-left: .0rem !important;
    border: .0rem;
}
::v-deep .mMain .el-table .cell{
  text-align: left ;
}
::v-deep .el-dialog__title{
  height: 3.3rem;
  font-size: 2.4rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #141B2D !important;
  line-height: 3.3rem;
}
::v-deep .el-dialog__header{
  background: none !important;
}
.el-button+.el-button{
  margin-left: 5.0rem;
}
::v-deep .el-dialog__headerbtn .el-dialog__close{
  color: #000 !important;
  font-size: 2.4rem;
}
.el-dialog__header {
    padding: 2.5rem 5.0rem 1.5rem !important;
}
::v-deep .el-dialog  .el-table thead th{
  background:#f8f8f8;
}

.el-dialog__headerbtn{
  position: absolute;
  top: 5.0rem !important;
  right:5.0rem !important;
}

</style>

